export default "__VITE_ASSET__CIzHGXeJ__"